/**
 * @file 基础api
 * @author haoyan
 */

/**
 * 等分数组
 *
 * @param {Array} arr 待处理的数组
 * @param {number} n 等分后每组元素个数
 * @param {string} emptyText 若等分后组内元素不满n个，使用此参数填充
 * @return {Array} 处理后的数组
 */
export const equal = (arr, n, emptyText) => {
    let result = [];
    if (arr && arr.length) {
        for (let i = 0; i < arr.length; i = i + n) {
            let seg = arr.slice(i, i + n);
            const len = seg.length;
            if (emptyText) {
                for (let j = 0; j < n - len; j++) {
                    seg.push(emptyText);
                }
            }
            result.push(seg);
        }
    }
    return result;
};


// WEBPACK FOOTER //
// ./src/utils/core.js